import {
    AnalyticsEvent,
    PageInfo
} from "@/services/tracking/types/analyticsEvent";

export interface GoogleAnalyticsPageInfo {
    name: string;
    url: string;
    category: string;
    type: string;
    language: string;
    variant?: string;
    timestamp?: string;
}

export type GoogleAnalyticsUserInfo =
    | {
          loginstatus: true;
          clientID: string;
          customerType: string | null;
      }
    | {
          loginstatus: false;
      };

export interface GoogleAnalyticsMinimumDataset {
    event: string;
    pageInfo: GoogleAnalyticsPageInfo;
    userInfo: GoogleAnalyticsUserInfo;
}

const formatTimestamp = (timestamp: number) =>
    timestamp
        ? new Date(timestamp).toLocaleString("nl-BE", {
              timeZone: "Europe/Brussels"
          })
        : undefined;

export const getPageInfo = (data: AnalyticsEvent): GoogleAnalyticsPageInfo => {
    const pageInfo: PageInfo = data.payload?.pageInfo || {};

    return {
        name: pageInfo.name || "",
        url: pageInfo.url || "",
        category: pageInfo.category || "",
        type: pageInfo.type || "",
        language: pageInfo.language || "",
        variant: pageInfo.variant,
        timestamp: formatTimestamp(pageInfo.timestamp)
    };
};

export const getUserInfo = (data: AnalyticsEvent): GoogleAnalyticsUserInfo => {
    if (data.payload.userInfo.loginStatus) {
        return {
            loginstatus: data.payload.userInfo.loginStatus,
            clientID: data.payload.userInfo.clientID,
            customerType: data.payload.userInfo.customerType
        };
    } else {
        return {
            loginstatus: data.payload.userInfo.loginStatus
        };
    }
};
